import { useEffect } from "react";
import SEO from "./SEO";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    
  <div className="max-w-4xl mx-auto px-4 py-10 shadow-2xl rounded-lg m-10">
    <SEO
      title="Privacy Policy | Pufframa – Buy Nicotine Products Online"
      description="Read the privacy practices of Pufframa.com regarding your personal data, cookies, comments, media uploads, and more. We value your privacy and data security."
      url="https://pufframa.com/privacy-policy"
      keywords="privacy policy, data protection, nicotine ecommerce, pufframa, cookies, GDPR compliance"
      structuredData={{
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "Privacy Policy",
        description:
          "Pufframa's privacy policy outlining how user data, cookies, and interactions are handled on our nicotine product platform.",
        url: "https://pufframa.com/privacy-policy"
      }}
    />
      <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center underline">Privacy Policy</h1>

      <section className="mb-6">
        <p className="text-gray-700">
          At <strong>Pufframa.com</strong>, we respect your privacy. This
          Privacy Policy explains what personal data we collect and why we
          collect it.
        </p>
      </section>

      {/* Section: Comments */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Comments</h2>
        <p className="text-gray-700">
          When visitors leave comments, we collect the data shown in the form,
          along with the IP address and browser user agent string to help with
          spam detection.
        </p>
        <p className="text-gray-700 mt-2">
          An anonymized string (hash) from your email may be sent to Gravatar.
          Read their{" "}
          <a
            href="https://automattic.com/privacy/"
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 underline"
          >
            privacy policy
          </a>
          . Once approved, your profile picture is publicly visible next to your comment.
        </p>
      </section>

      {/* Section: Media */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Media</h2>
        <p className="text-gray-700">
          If you upload images, avoid including location data (EXIF GPS), as
          visitors can download and extract it.
        </p>
      </section>

      {/* Section: Cookies */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Cookies</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li>
            Leaving a comment may save your name, email, and website in cookies
            for one year.
          </li>
          <li>
            When you log in, we set cookies to save login and display
            preferences.
          </li>
          <li>
            If you select "Remember Me", login will persist for two weeks.
          </li>
          <li>
            Editing or publishing an article stores a cookie (post ID), which
            expires in 1 day.
          </li>
        </ul>
      </section>

      {/* Section: Embedded Content */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Embedded Content
        </h2>
        <p className="text-gray-700">
          Articles may include embedded content (e.g., videos, images, etc.)
          from other websites. These sites may collect data, use cookies, and
          monitor your interaction.
        </p>
      </section>

      {/* Section: Data Retention */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          How Long We Retain Your Data
        </h2>
        <p className="text-gray-700">
          Comments and their metadata are retained indefinitely. If you
          register, we store personal info in your profile. You can view, edit,
          or delete your data anytime.
        </p>
      </section>

      {/* Section: Your Rights */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Your Data Rights
        </h2>
        <p className="text-gray-700">
          If you have an account or have left comments, you can request an
          exported file of your data or ask for its deletion (except data
          required by law).
        </p>
      </section>

      {/* Section: Where Data Goes */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Where We Send Your Data
        </h2>
        <p className="text-gray-700">
          Visitor comments may be checked through automated spam detection
          services.
        </p>
      </section>

      {/* Section: Contact */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Contact Us</h2>
        <p className="text-gray-700">
          For questions regarding this policy, contact us at{" "}
          <a
            href="mailto:your@email.com"
            className="text-blue-600 underline"
          >
          pufframa@gmail.com
          </a>
          .
        </p>
      </section>
    </div>
  );
};

export default Privacy;
